import React from 'react';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';

export default function Utilities() {
  return (
    <div>
      <PageHeader icon={Icon.utilities} title="Utilities" subtitle="Fuel prices, mileage tools, and more" color={SECTION_COLOR.utilities} />
      <p className="empty">Utilities will live here. Coming soon.</p>
    </div>
  );
}
